import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private snackBar = inject(MatSnackBar);

  openSnackBar(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      verticalPosition: 'top',
      duration: 2000
    });
  }

  constructor() { }
}
